import React from "react";
import { EntriesIcon, PickIcon } from "@picklebet/ui";
import { TitleIcon } from "@/features/shell/components/shared/TitleIcon";
import type { Titles } from "@/hooks/graphql/useTitles";
import { samePath } from "../utils/isNavItemActive";
import type { NavItem, NavLocation } from "../types";
import { link } from "./shared";

const sportParam = ({ search }: NavLocation) =>
  new URLSearchParams(search).get("sport");

export const pickems = (
  titles: Titles,
  contestsCounts: Record<string, number>,
): NavItem => ({
  id: "pickems",
  text: "Pick’ems",
  icon: <PickIcon />,
  target: link("/pickems"),
  activeWhen: ({ pathname }) => pathname.split("/").includes("pickems"),
  children: [
    {
      id: "pickems/all",
      text: "All Pick’ems",
      icon: <EntriesIcon />,
      target: link("/pickems"),
      activeWhen: (location) =>
        samePath("/pickems")(location) && !sportParam(location),
    },
    ...Object.values(titles).flatMap((title): NavItem | [] => {
      const count = contestsCounts[title.slug];
      if (!count) return [];

      return {
        id: `pickems/${title.slug}`,
        text: title.name,
        icon: <TitleIcon title={title} />,
        target: link(`/pickems/?sport=${title.slug}`),
        badge: count,
        activeWhen: (location) =>
          samePath("/pickems")(location) && sportParam(location) === title.slug,
      };
    }),
  ],
});
